/** @jsxImportSource @emotion/react */
import InfoTip, {P} from './info-tip';

const StartDayTimeInfo = function () {
  return (
    <InfoTip
      info={
        <section css={{width: 415}}>
          <h3>日切換時間</h3>
          <P>
            依據此時間定義此班次切換次日的時間，若下班時間超過此設定會影響下班打卡
            例如: 設定常日班次切換時間為02:00，則5/1上班的同仁加班至5/2
            02:30(即為過02:00)則無法打在5/1下班卡
          </P>
        </section>
      }
    />
  );
};

export default StartDayTimeInfo;
